import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import discointCodePolicyFetcherHoc from "@hocs/discountCodePolicyFetcherHoc";
import {DiscountCodePolicy} from "../../models/discountCodePolicy";


const Option = Select.Option;


export interface DiscountCodePolicyMultiSelectionReturnValue {
  new_approachs: string[];
  deleted_approachs: string[];
  selectedItems: DiscountCodePolicy[]
}

type DiscountCodePolicySelectionProps = {
  mode: SelectionMode,
  onChange: (value: DiscountCodePolicyMultiSelectionReturnValue) => void
  selectedDiscountCodePolicys: DiscountCodePolicy[],
  data: DiscountCodePolicy[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: DiscountCodePolicy[] | DiscountCodePolicy | null
}


const DiscountCodePolicysSelection: React.FC<DiscountCodePolicySelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, disabled, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected approachs before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(item => {
        if (returnData.findIndex(opt => opt.id === item.id) === -1) {
          returnData.push(item)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_approachs = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_approachs = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_approachs,
        new_approachs,
        selectedItems: option.map(opt => opt.props.approach)
      });
    }
    else {
      onChange(option.props.approach)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      disabled={disabled}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(item =>
        <Option key={item.id} approach={item}>{item.title}</Option>
      )}
    </Select>
  );
};

export default discointCodePolicyFetcherHoc(DiscountCodePolicysSelection);


